import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { SelectedSearchTermsPage } from "~/pages/selected-search-terms/selected-page";

export const Route = createFileRoute("/_app/search-terms/selected-books")({
  head: () => ({
    meta: [{ title: i18n.t("general:documentTitle.selectedBooks") }],
  }),
  component: SelectedSearchTermsPage,
});
